import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_food_all: FaireCategoryEntity = {
  token: "cat_food-all",
  type: "category",
  name: "All food & drink",
  level: 2,
  parentToken: "cat_food-drink",
  href: "/category/food-drink",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
